<template>
<div class="mine-page" v-loading="pageLoading">
    <examin-header title="考试试卷"></examin-header>
    <div class="main" v-if="info">
        <p class="examinTitle">{{info.name}}</p>
        <p class="examinInfo">满分{{info.score}}分，{{info.pass}}分合格</p>
        <p class="examinBtn" @click="toExamin">开始答题</p>
    </div>
</div>
</template>

<script>
import ExaminHeader from '../components/ExaminHeader.vue';
export default {
  name: "examin",
  data() {
    return {
      pageLoading: true,
      info: null,
    }
  },
  components:{ExaminHeader},
  mounted() {
    this.id = this.$route.query.id
    this.getData();
  },
  destroyed() {},
  computed: {
    plat() {
      return this.$store.state.plat_id
    }
  },
  methods: {
    
    toExamin(){
      this.$router.push({
        path:'./examinList',
        query:{
          isExamin:true,
          id:this.id
        }
      })
    },
    async getData() {
      this.pageLoading = true;
      let res = await this.$api({
        method: "get",
        url: "/api/flat/test/index",
        data: {
          test_id: this.id,
        },
      });
      this.pageLoading = false;
      if (res.code == 0) {
        this.info = res.data.test_detail;
      } else {
        this.$toast(res.msg);
      }
    },

  },
  beforeRouteUpdate(to, from, next) {
    console.log('beforeRouteUpdate')
    // console.log(to)
    next()
  },

};
</script>

<style lang="scss" scoped>
.mine-page {
  background: url("https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/%E7%BC%96%E7%BB%84%202.png");
  background-size: cover;
  height: 100vh;
  width: 100vw;
  text-align: center;
  color: #FFFFFF;
  overflow: hidden;
  
}
.examinTitle{
  font-size: 48px;
  font-weight: 600;
  line-height: 67px;
  text-shadow: 0px 2px 4px #D7633A;
  margin-top: 140px;
  margin-bottom: 25px;
}
.examinInfo{
  font-size: 34px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 48px;
  text-shadow: 0px 2px 4px #E67143;
}
.examinBtn{
  position: fixed;
  bottom:171px;
  left:50%;
  transform: translateX(-50%);
  width: 476px;
  height: 102px;
  border-radius: 51px;
  border: 1px solid #FFFFFF;
  font-size: 46px;
  line-height: 102px;
}
</style>

<style lang="scss">

</style>
